<div class="info__item__text">
  <p>
    ESi Holding LTD trading as Esi.one of Tallinn, Estonia, <a
      title="some title"
      href="/home"
      target="_blank">www.esi.one</a
    > (hereinafter "ESI" or "we") is committed to protecting and respecting your
    privacy.
  </p>
  <p>
    This policy (together with our main Cookie Policy and any other documents
    referred to in it) sets out the basis on which any personal data (as defined
    in the General Data Protection Regulation (“GDPR”)) (the “Personal Data”) we
    collect from account holders or individual users or visitors to our website,
    or that is uploaded to our website, will be processed by us. Account
    holders, users and visitors of our website or owners of Personal Data
    collected by us (each, “you”) should read the following carefully to
    understand our views and practices regarding your Personal Data and how we
    will treat it.
  </p>
  <p>
    By providing any Personal Data to us, you consent to the collection, use,
    disclosure and transfer of such Personal Data in the manner and for the
    purposes set out below.
  </p>
  <div class="legal__row">
    <div class="legal__row__head">Information We May Collect</div>
    <p>
      We may collect and process the following data which may contain Personal
      Data:
    </p>
    <ul role="list">
      <li>
        information that you provide by filling in forms, including information
        provided at the time of registering to use our website, subscribing to
        any services provided by us, posting material, reporting a problem with
        our website, or requesting further services;
      </li>
      <li>
        information, data, documents or images that you upload onto our website;
      </li>
      <li>details of transactions you carry out through our website;</li>
      <li>
        details of your visits to our website, resources that you access and
        actions you are working on through the website;
      </li>
      <li>and if you contact us, a record of that correspondence.</li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Log file during website visit</div>
    <p>Our website logs your website visit. In doing so, we process:</p>
    <ul role="list">
      <li>date and time of the access,</li>
      <li>the amount of data transferred,</li>
      <li>the browser type and version,</li>
      <li>the operating system you use,</li>
      <li>the referrer URL (the previously visited web site),</li>
      <li>your IP address,</li>
      <li>the requesting provider.</li>
    </ul>
    <p>
      The legal basis for data processing is my legitimate interest in the
      ongoing provision and security of our website. The log file is deleted
      after seven days, unless it is needed to prove or clarify specific legal
      violations that have become known within the retention period.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">IP Addresses</div>
    <p>
      We may also collect and process information about your computer, including
      where available your IP address, operating system and browser type, for
      system administration and to report aggregate information to our business
      partners. This is statistical data about our users’ browsing actions and
      patterns and does not identify any individual.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Cookies</div>
    <p>
      Please refer to our Cookie Policy for more information on how we use
      cookies.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Where We Store Your Data</div>
    <p>
      The Personal Data that we collect may be transferred to, and stored at, a
      destination outside Germany and the EEA. It may also be processed by staff
      operating outside Germany and the EEA who work for us or for one of our
      suppliers. Such staff maybe engaged in, among other things, the fulfilment
      of your services ordered by you, the processing of your payment details
      and the provision of support services. We will take all steps reasonably
      necessary to ensure that your Personal Data is treated securely and in
      accordance with this privacy policy.
    </p>
    <p>
      All information you provide to us is stored on our secure servers. Where
      we have given you (or where you have chosen) a password which enables you
      to access certain parts of our website, you are responsible for keeping
      this password confidential. We ask you not to share the password with
      anyone.
    </p>
    <p>
      Unfortunately, the transmission of information via the internet is not
      completely secure. Although we will do our best to protect your Personal
      Data, we cannot guarantee the security of your Personal Data transmitted
      to our website; any transmission is at your own risk. Once we have
      received your information, we will use strict procedures and security
      features to try to prevent unauthorised access.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Uses made of the information</div>
    <p>
      We use information held, including Personal Data, in the following manner:
    </p>
    <ul role="list">
      <li>
        to ensure that content from our website is presented in the most
        effective manner for you and for your computer;
      </li>
      <li>
        to provide you with information or services that you request from us,
        and to otherwise carry out our obligations arising from any contracts
        entered into between you and us;
      </li>
      <li>
        to provide you with information, products or services which we feel may
        interest you, where you have consented to be contacted for such
        purposes;
      </li>
      <li>
        to allow you to participate in interactive features of our service, when
        you choose to do so;
      </li>
      <li>to notify you about changes to our services;</li>
      <li>
        to investigate any complaints relating to the use of our website or any
        suspected unlawful activities;
      </li>
      <li>
        complying with any applicable laws, regulations, codes of practice,
        guidelines, or rules, or to assist in law enforcement and investigations
        conducted by any governmental and/or regulatory authority;
      </li>
      <li>any other purposes for which you have provided the information;</li>
      <li>
        and carrying out whatever else is reasonable or related to or in
        connection with the above and our provision of goods and/or services to
        you.
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Disclosure of your information</div>
    <p>We may disclose your Personal Data to third parties:</p>
    <ul role="list">
      <li>
        for the purposes of providing products or services that you request from
        us, fulfilling our obligations arising from any contracts entered into
        between you and us, processing payments in connection therewith or
        otherwise in connection with your use of our website;
      </li>
      <li>
        where a third party claims that any content posted or uploaded by you to
        our website constitutes a violation of their rights under applicable
        law, in which case we may disclose your identity to that third party;
      </li>
      <li>
        in the event that we sell or buy any business or assets, in which case
        we may disclose your Personal Data to the prospective seller or buyer of
        such business or assets; or
      </li>
      <li>
        if we or substantially all of our shares or assets are acquired by a
        third party, in which case Personal Data held by us about our customers
        will be one of the transferred assets.
      </li>
    </ul>
    <p>
      We may also disclose your Personal Data to a governmental or regulatory
      body, law enforcement, or other authorities, in order to enforce our terms
      of use for the website, to cooperate with any direction, request or order
      from such parties or to report any suspected unlawful activity.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Consent</div>
    <p>
      By providing your Personal Data to us, you consent to the collection, use
      and disclosure of your Data by us for the purposes set out in this privacy
      policy (“Purposes”).
    </p>
    <p>
      Where any Personal Data relates to a third party, you represent and
      warrant that the Personal Data is up-to-date, complete, and accurate and
      that you have obtained the third party’s prior consent for our collection,
      use and disclosure of their Personal Data for the Purposes. You agree that
      you shall promptly provide us with written evidence of such consent upon
      demand by us.
    </p>
    <p>
      Each use of our services by you shall constitute a fresh agreement for us
      to collect, use and disclose the Personal Data in accordance with this
      privacy policy.
    </p>
    <p>
      You may withdraw your consent and request us to stop using and/or
      disclosing your Personal Data for any or all of the Purposes by submitting
      your request to us in writing to Contact@esi.one. Should you withdraw your
      consent to the collection, use or disclosure of your Personal Data, it may
      impact our ability to proceed with your transactions, agreements or
      interactions with us. Prior to you exercising your choice to withdraw your
      consent, we will inform you of the consequences of the withdrawal of your
      consent. Please note that your withdrawal of consent will not prevent us
      from exercising our legal rights (including any remedies) or undertaking
      any steps as we may be entitled to at law.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Your data subject rights</div>
    <p>
      <em class="italic__legal">a) Information</em><br />Upon request, we will
      provide you at any time and free of charge with information about all
      personal data that we have stored about you.
    </p>
    <p>
      <em class="italic__legal"
        >b) Correction, deletion, restriction of processing (blocking),
        objection</em
      ><br />If you no longer agree with the storage of your personal data or if
      this data has become incorrect, we will arrange for the deletion or
      blocking of your data or make the necessary corrections (insofar as this
      is possible according to the applicable law) on the basis of a
      corresponding instruction. The same applies if we are only to process data
      in a restrictive manner in the future. You have the right to object in
      particular in cases where your data is required for the performance of a
      task that is in the public interest or in our legitimate interest, as well
      as profiling based on this. You also have such a right of objection in the
      event of data processing for the purpose of direct advertising.
    </p>
    <p>
      <em class="italic__legal"
        >c) Right to revoke consent with effect for the future</em
      ><br />You may revoke your consent at any time with effect for the future.
      Your revocation will not affect the lawfulness of the processing up to the
      time of revocation.
    </p>
    <p>
      <em class="italic__legal">d) Data portability</em><br />If data is
      processed on the basis of a contract, pre-contractual negotiations,
      consent or with the help of automated procedures, you have the right to
      data portability. Upon request, we will provide you with your data in a
      common, structured and machine-readable format so that you can transfer
      the data to another data controller if you wish.
    </p>
    <p>
      <em class="italic__legal"
        >f) Exercise of your data subject rights and right of appeal</em
      ><br />To assert these rights, please contact us using Contact@esi.one.
      The same applies if you have questions about data processing in our
      company. You also have the right to lodge a complaint with a data
      protection supervisory authority.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Accuracy</div>
    <p>
      We endeavour to ensure that all decisions involving your Personal Data are
      based upon accurate and timely information. However, we rely on you to
      disclose all relevant information to us and to inform us of any changes in
      your Personal Data. As such, please disclose all relevant information
      necessary for us to provide services to you and ensure all information
      submitted to us is up-to-date, complete, and accurate. Kindly inform us
      promptly if there are any changes in your Personal Data.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Assumption of Risk</div>
    <p>
      You agree to defend and indemnify us and any of our affiliates (if
      applicable) and hold us harmless against any legal claims and demands,
      including reasonable legal fees, which may arise from or relate to your
      use or misuse of the website or Services, your breach of this Agreement,
      or your conduct or actions. You agree that we shall be able to select its
      legal counsel and may participate in its defence if we wish.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Retention</div>
    <p>
      We may retain your Personal Data for at least 10 years, or such other
      longer or shorter period as may be necessary to fulfil the purpose for
      which it was collected, or as required or permitted by applicable laws. We
      will cease to retain your Personal Data or remove the means by which the
      data can be associated with you, as soon as it is reasonable to assume
      that such retention no longer serves the purpose for which the Personal
      Data was collected, and is no longer necessary for legal or business
      purposes.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Third Party Policies</div>
    <p>
      Our website may, from time to time, contain links to and from the websites
      of our partner networks, business partners and affiliates. If you follow a
      link to any of these websites, please note that these websites have their
      own privacy policies and that we do not accept any responsibility or
      liability for these policies. Please check these policies before you
      submit any Data to these websites.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">
      Automated decisions in individual cases including profiling
    </div>
    <p>
      We do not use automated decision-making - including profiling in
      accordance with Article 22(1) and (4) of the GDPR.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Data security</div>
    <p>
      We use technical and organisational security measures to protect the
      processing of personal data, in particular against accidental or
      intentional manipulation, loss, destruction or against attack by
      unauthorised persons. Our security measures are continuously improved in
      line with technological developments.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Changes</div>
    <p>
      This policy and our commitment to protecting the privacy of your personal
      data can result in changes to this policy. Please regularly review this
      policy to keep up to date with any changes.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Queries and Complaints</div>
    <p>
      Any comments or queries on this policy should be directed to us. If you
      believe that we have not complied with this policy or acted otherwise than
      in accordance with data protection law, then you should notify us.
    </p>
  </div>
</div>
<div class="info__item__text">
  <p>
    In this Cookie Policy we, ESi Holding LTD trading as Esi.one Tallinn,
    Estonia, <a href="/home" target="_blank">www.esi.one</a> (hereinafter "Esi.one"
    or "we") inform you about cookies and ways to manage your consent. respects your
    privacy and takes the protection of your personal data very seriously. We also
    inform you about how and which cookies are used on this website and how you can
    manage your consent to store cookies.
  </p>
  <p>
    For more information about how we protect your personal data, please see our
    privacy policy.
  </p>
  <div class="legal__row">
    <div class="legal__row__head">What are cookies?</div>
    <p>
      Cookies are small files that are stored on your computer when you visit a
      website. The next time you visit, the website can recognise the file. The
      files are thus typically used to compile statistics or for behavioural
      advertising purposes. Cookies help us to provide you with our services on
      our website and are partly necessary for website functionality purposes.
      The personal data stored in our cookies is encrypted.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Third-party cookies</div>
    <p>We collect and process data for the following purposes:</p>
    <ul role="list">
      <li>Optimisation of the website and your user experience</li>
      <li>
        Creation of statistics on the use of the website by you and other users
      </li>
      <li>
        Creation of statistics and analyses with the aim of improving our
        products, services and technologies
      </li>
      <li>
        Advertising purposes, including profiling and behavioural advertising
        initiatives, so that we can make our product information and offers as
        relevant as possible to you
      </li>
      <li>
        Compliance with applicable legal requirements (e.g., General Data
        Protection Regulation (GDPR) and the Privacy and Electronic
        Communications Regulations (PECR)), including documentation
        requirements:
      </li>
      <li>
        Compliance with basic principles concerning the processing of personal
        data and legal basis for the processing (e.g., obtaining consent)
      </li>
      <li>
        Implementation and maintenance of technical and organisational security
        measures
      </li>
      <li>
        Investigation of suspected or known security breaches and notification
        to data subjects and authorities
      </li>
      <li>Statistics on the use of the website</li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">How long are cookies stored?</div>
    <p>
      Cookies are stored on your computer for different lengths of time
      depending on their type. From a technical point of view, a distinction is
      made between two types of cookies:
    </p>
    <p>
      <em>Session cookies:</em> session cookies are used, for example, to temporarily
      store the items in your shopping cart while you navigate the website. Session
      cookies are not stored on your device and disappear when you close your browser.
    </p>
    <p>
      <em>Persistent Cookies: </em>Persistent cookies are stored as text files
      on your device. Persistent cookies allow our server to recognise your
      device the next time you visit our website.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">
      Why do we provide information about cookies?
    </div>
    <p>
      The provision of information about our use of cookies is in accordance
      with the Privacy and Electronic Communications Regulation on Mandatory
      Provision of Information and Mandatory Consent in the context of data
      storage or data access on end-user devices. The legal basis for the
      collection of your personal data through cookies, including for profiling
      purposes, is your consent.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">
      Who should I contact for more information?
    </div>
    <p>
      If you have any questions or comments about our Cookie Policy or wish to
      exercise your rights under applicable laws, please contact us using <a
        href="mailto:Contact@esi.one">Contact@esi.one</a
      >.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Why do we use cookies?</div>
    <p>
      We use cookies to personalise content and ads, to provide social media
      features and to analyse our traffic. We also share information about your
      use of our site with our social media, advertising and analytics partners
      who may combine it with other information that you’ve provided to them or
      that they’ve collected from your use of their services.
    </p>
    <p>
      Cookies are small text files that can be used by websites to make a user’s
      experience more efficient. The law states that we can store cookies on
      your device if they are strictly necessary for the operation of this site.
      For all other types of cookies, we need your permission.
    </p>
    <p>
      This site uses different types of cookies. Some cookies are placed by
      third party services that appear on our pages.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Types of cookies</div>
    <p>There are different types of cookies:</p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><em>Functional cookies</em></div>
    <p>
      Functional cookies are essential cookies to provide a correct and
      user-friendly website. Some examples:
    </p>
    <ul role="list">
      <li>Storing your language preferences;</li>
      <li>Detecting abuse or fraud;</li>
      <li>
        Storing browser settings to display the website according to the screen
        size.
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><em>Analytical cookies</em></div>
    <p>
      These cookies are typical third party cookies that we use to collect
      statistical data about how our website is used, including:
    </p>
    <ul role="list">
      <li>Average page load time;</li>
      <li>Pages visited;</li>
      <li>Browser data;</li>
      <li>IP address;</li>
      <li>MAC address;</li>
      <li>Duration of a (page) visit;</li>
      <li>Data about the operating system;</li>
      <li>Data about the device used;</li>
      <li>Clicking behaviour and other interactions on one or more pages.</li>
    </ul>
    <p>
      The main purpose of these cookies and their statistical data is, after
      analysis, to optimise our performance, security, usability, content and
      services.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Non-essential Cookies</div>
    <p>
      Non-essential Cookies are any cookies that do not fall within the
      definition of essential cookies, such as cookies used to analyse your
      behaviour on a website (‘analytical’ cookies) or cookies used to display
      advertisements to you (‘advertising’ cookies).
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">How can I prevent and delete cookies?</div>
    <p>
      When you visit our website, one or more cookies are automatically stored
      on your device. If you do not want this to happen, it is best to use the
      following links (depending on the browser you use) to set your browser to
      prevent cookies from being stored on your computer in the future.
    </p>
    <ul role="list">
      <li>
        Delete cookies in <a
          href="https://support.google.com/chrome/answer/95647?hl=en-GB&amp;co=GENIE.Platform%3DDesktop"
          target="_blank"
        >
          Google Chrome</a
        >
      </li>
      <li>
        Delete cookies in <a
          href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox"
          target="_blank">Mozilla Firefox</a
        >
      </li>
      <li>
        Deleting <a
          href="https://www.wikihow.com/Delete-Flash-Cookies"
          target="_blank">Flash cookies</a
        >
      </li>
      <li>
        Delete cookies in <a
          href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
          target="_blank">Microsoft Internet Explorer</a
        >
      </li>
      <li>
        Delete cookies in <a
          href="https://www.opera.com/uk/use-cases/clean-browser-and-remove-trackers"
          target="_blank">Opera</a
        >
      </li>
      <li>
        Delete cookies in <a
          href="https://support.apple.com/en-gb/HT201265"
          target="_blank">Safari</a
        >
      </li>
    </ul>
    <p>
      If your browser is not listed above, it's best to check your browser's
      help menu or search the Internet for "cookies" in conjunction with your
      browser's name.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Does this policy change?</div>
    <p>
      We may update our Cookie Policy from time to time. This might be for a
      number of reasons, such as to reflect a change in the law or to
      accommodate a change in our business practices and the way we use cookies.
      We recommend that you check here periodically for any changes to our
      Cookie Policy.
    </p>
  </div>
</div>
<style>
 p{
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 10px;
  }
  </style>